import { Component } from "react"
import PropTypes from "prop-types"
import { Button, IconButton, Typography } from "@mui/material"
import { CloudDownload } from "@mui/icons-material"
import { isEmpty } from "lodash"
import ConfirmIntegrationDialog from "../confirm-integration-dialog"
import ATLogo from "./atlogo"
import { Link } from "react-router-dom"
import { STATUSES } from "modules/platform/constants"
import withNavigate from "hocs/withNavigate"

import "./style.scss"

const { NONE, REQUESTED, ACTIVE } = STATUSES

class ATIntegration extends Component {
  static propTypes = {
    account: PropTypes.string.isRequired,
    openDialog: PropTypes.func.isRequired,
    closeDialog: PropTypes.func.isRequired,
    atIntegrationPermission: PropTypes.func.isRequired,
    atStatus: PropTypes.oneOf([NONE, REQUESTED, ACTIVE]),
    terms: PropTypes.string,
    termsVersion: PropTypes.number,
    legalAccountName: PropTypes.string,
    isSuperuser: PropTypes.bool.isRequired,
    navigate: PropTypes.func.isRequired,
  }

  confirm = () => {
    const { openDialog, closeDialog, terms, termsVersion, isSuperuser } = this.props

    if (isSuperuser) {
      this.enableAT()
      return
    }

    openDialog({
      title: <div id="at-integration-dialog-header">
        <Typography variant="h6">Alpha Theory Permissions</Typography>
        <IconButton
          className="download"
          color="secondary"
          variant="contained"
          component="a"
          target="_blank"
          href={`https://assets.ompnt.com/terms/Alpha_Theory_Omega_Point_Integration_Permissions.v${termsVersion}.pdf`}
          download
          size="large"
        >
          <CloudDownload />
        </IconButton>
      </div>,
      content: <ConfirmIntegrationDialog closeDialog={closeDialog} confirm={this.enableAT} termsText={terms} />,
    })
  }

  enableAT = (legalText) => {
    const { account, closeDialog, atIntegrationPermission, navigate } = this.props
    atIntegrationPermission(account, window.location.href, legalText)
    closeDialog()
    navigate(`/${account}/home/resources`)
  }

  CTA = () => {
    const { atStatus, account, legalAccountName } = this.props
    if (atStatus === NONE) {
      return <Button disabled={isEmpty(legalAccountName)} color="primary" className="confirm" onClick={this.confirm}>Start integration</Button>
    }
    if (atStatus === ACTIVE) {
      return <Button color="primary" className="confirm"><Link to={`/${account}/applications/alpha-theory`}>Get started</Link></Button>
    }

    return <Button color="primary" disabled variant="outlined" className="confirm">Request pending</Button>
  }

  render() {
    return <div id="at-integration" className="app-card integration">
      <ATLogo />
      <div className="header">
        <div className="name-wrapper">
          <div className="name">Alpha Theory (Legacy)</div>
        </div>
      </div>
      <div className="body">
        <p className="description">This integration allows mutual customers to import their portfolios and forecasts from Alpha Theory into Omega Point&apos;s ecosystem.</p>
        {this.CTA()}
      </div>
    </div>
  }
}

export default withNavigate(ATIntegration)
